import { SystemState } from 'src/app/_model/client-state';

export enum ServicejobActionType {
  START,
  STOP,
  CHANGE
}

export class ServicejobRemoteActionType {
  static readonly START_OF_SERVICEJOB = new ServicejobRemoteActionType(
    'startofservicejob',
    'SERVICEJOB-REMOTEACTION.SOSJ.PAGE-TITLE',
    'SERVICEJOB-REMOTEACTION.SOSJ.DESCRIPTION',
    'SERVICEJOB-REMOTEACTION.SOSJ.TITLE',
    'SERVICEJOB-REMOTEACTION.SOSJ.RA.LABEL.SHORT',
    'SERVICEJOB-REMOTEACTION.SOSJ.RA.LABEL.LONG'
  );
  static readonly END_OF_SERVICEJOB = new ServicejobRemoteActionType(
    'endofservicejob',
    'SERVICEJOB-REMOTEACTION.EOSJ.PAGE-TITLE',
    'SERVICEJOB-REMOTEACTION.EOSJ.DESCRIPTION',
    'SERVICEJOB-REMOTEACTION.EOSJ.TITLE',
    'SERVICEJOB-REMOTEACTION.EOSJ.RA.LABEL.SHORT',
    'SERVICEJOB-REMOTEACTION.EOSJ.RA.LABEL.LONG'
  );
  static readonly CHANGE_OF_SERVICEJOB = new ServicejobRemoteActionType(
    'changeofservicejob',
    'SERVICEJOB-REMOTEACTION.COSJ.PAGE-TITLE',
    'SERVICEJOB-REMOTEACTION.COSJ.DESCRIPTION',
    'SERVICEJOB-REMOTEACTION.COSJ.TITLE',
    'SERVICEJOB-REMOTEACTION.COSJ.RA.LABEL.SHORT',
    'SERVICEJOB-REMOTEACTION.COSJ.RA.LABEL.LONG'
  );

  // private to disallow creating other instances of this type
  private constructor(
    public readonly endpoint: string,
    public readonly pageTitle: string,
    public readonly descriptionKey: string,
    public readonly titleKey: string,
    public readonly raShortLabel: string,
    public readonly raLongLabel: string
  ) {}
}
